import { Capacitor } from '@capacitor/core'

export const ENV_IS_PRODUCTION = import.meta.env.PROD
export const ENV_IS_DEVELOPMENT = !ENV_IS_PRODUCTION
export const IS_MOBILE_MODE = import.meta.env.MODE === 'mobile'

export const API_URL = ENV_IS_PRODUCTION
  ? 'https://api.cretesuite.com'
  : import.meta.env.VITE_APP_CRETESUITE_API || 'http://localhost:4000'

// Days the persisted graphcache survives between sessions (urql default: 7).
// Kept generous so a crew member offline for a long weekend still has the
// cached data that backs offline reads and optimistic updates.
export const GRAPH_CACHE_MAX_AGE = (() => {
  const raw = import.meta.env.VITE_GRAPH_CACHE_MAX_AGE
  if (!raw) return 7
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : 7
})()

export const PLAUSIBLE_DOMAIN =
  ENV_IS_PRODUCTION && !import.meta.env.VITE_IS_LOCAL
    ? 'cretesuite.com'
    : 'cretesuite.local'

export const PACKAGE_VERSION = import.meta.env.VITE_PACKAGE_VERSION ?? '0.0.0'
export const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION ?? '0'

export const CAPACITOR_UPDATER_ENABLED =
  Capacitor.isNativePlatform() && ENV_IS_PRODUCTION

// Web deploy-version polling (WebUpdateOnNavigation); native updates via Capgo.
export const WEB_UPDATER_ENABLED =
  !Capacitor.isNativePlatform() && ENV_IS_PRODUCTION

export const CAPGO_CHANNEL = import.meta.env.VITE_CAPGO_CHANNEL

export const COGNITO_USER_POOL_ID =
  import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-2_aMKXsW6ey'
export const COGNITO_CLIENT_ID =
  import.meta.env.VITE_COGNITO_CLIENT_ID || '4oq12jnk4kvokbmbhm2rvid2mo'

export const ONE_SIGNAL_APP_ID = '63d3b105-3b51-4448-a2d1-cb2a5da5b542'

// Sentry project "crew-app" (org cretesuite). The DSN is public by design;
// reporting is on in production builds only (web and native).
export const SENTRY_DSN =
  'https://a5b56c1962e49ca9c4da8696ca2396ef@o4508614204850176.ingest.us.sentry.io/4512205525876736'
export const SENTRY_ENABLED = ENV_IS_PRODUCTION
export const PRODUCTION_WEB_HOST = 'crew.cretesuite.com'
// Injected by vite.config so the runtime and the source-map upload agree
export const SENTRY_RELEASE =
  import.meta.env.VITE_SENTRY_RELEASE ?? `crew-app@${PACKAGE_VERSION}`

/**
 * API client ID — used by api-client-auth to identify this app.
 * Same client IDs as crew-app v1.
 */
export const API_CLIENT_ID = (() => {
  if (IS_MOBILE_MODE && ENV_IS_PRODUCTION) {
    return '87688a9066:ae1c98ad52ea9d907bf80bf7918ab5b9abcb2f6eee7b51ee9f22ea55e476116ce872fb353e4250b555a953b111dc5ef79ffde87cc110c2ca36dd0c5db8ea7c3a5d6078860cd5f0b11b838ab231b75426'
  }
  if (ENV_IS_PRODUCTION) {
    return '5c0f1fd29a:e6041ad91666336470853c77125656470043299dbfabed058a48131cae7accafa78deeb18dacaf02bf8954d95226f4eb9bbcc5ad85dc8bd1049611541ac4093ffff81e6d158d8dfdcc6370713ec71700'
  }
  if (IS_MOBILE_MODE) {
    return 'f026dd36af:5b9d721a3fb100b9a2fb37076b8963b2ca4c271bf51282e15c846763fa4bf0fa0f97e387e6862cd66e078096f8ba4fffa644a709cdf6c75eb1ba1bd1b8f90847ddc0c18d8ebd15e18bc8d58146e4807c'
  }
  return '62c04e42a3:f6e722272b1dded15f47c706cfa8cf7eadcc4bbb182eb4f11fe5bc8f7db4e05499a26575f26b30cd8d494a0d07ed29fcfe0454e02299a57c35586b98cfc4412870b8b52cee6fd2394166b9756c7358c9'
})()
